import React from 'react';
import { DealerListRender } from './DealerListRender';
import { AvailabilityRender } from './AvailabilityRender';
import { ProductConfigRender } from './ProductConfigRender';
import { PricingMarkupRender } from './PricingMarkupRender';
import { InitialCreationRender } from './InitialCreationRender';
import { ProductCatalogDocumentsRender } from './ProductCatalogDocumentsRender';
import {
  DealerListChanges,
  AvailabilityChanges,
  ProductConfigChanges,
  PricingMarkupChanges,
  ProductChangeLogTableRow,
  ProductCatalogDocumentsChanges,
} from '../../../../types';

interface ChangesCellProps {
  log: ProductChangeLogTableRow;
}

export const ChangesCell = ({ log }: ChangesCellProps) => {
  switch (log.changeType) {
    case 'AVAILABILITY':
      return <AvailabilityRender changes={log.changes as AvailabilityChanges} />;
    case 'DEALER_LIST':
      return <DealerListRender changes={log.changes as DealerListChanges} />;
    case 'INITIAL_CREATION':
      return <InitialCreationRender />;
    case 'PRODUCT_CATALOG_DOCUMENTS':
      return <ProductCatalogDocumentsRender changes={log.changes as ProductCatalogDocumentsChanges} />;
    case 'PRODUCT_CONFIG':
      return <ProductConfigRender changes={log.changes as ProductConfigChanges} />;
    case 'PRICING_MARKUP':
      return <PricingMarkupRender changes={log.changes as PricingMarkupChanges} />;
    default:
      return null;
  }
};
